export default "__VITE_ASSET__SuPmr$Gm__"